import Vue from 'vue'
import Router from 'vue-router'
import constants from "../constants";
import lodash from "lodash"
import main from "../main";

const ComboDetail = () => import('@/components/combo/ComboDetail.vue');
const Register = () => import('@/pages/Register.vue');
const ForgotPassword = () => import('@/pages/ForgotPassword.vue');
const SetNewPassWord = () => import('@/pages/SetNewPassword.vue');
const Profile = () => import('@/pages/Profile.vue');
const EditProfile = () => import('@/pages/EditProfile.vue');
const Ponta = () => import('@/pages/Ponta.vue');
const AddLocation = () => import('@/pages/Location.vue');
const Careers = () => import('@/pages/static/Career.vue');
const News = () => import('@/pages/static/News.vue');
const Aboutus = () => import('@/pages/static/Aboutus.vue');
const History = () => import('@/pages/History.vue');
const Post = () => import('@/pages/static/Post.vue');
const Faq = () => import('@/pages/static/Faq.vue');
const Crs = () => import('@/pages/static/Crs.vue');
const TestLocalization = () => import('@/pages/TestLocalization.vue');
const ResultLocalization = () => import('@/pages/ResultLocalization.vue');
const Confirmation = () => import('@/pages/Confirmation.vue');
const PaymentStatus = () => import('@/pages/PaymentStatus.vue');
const TopicList = () => import('@/pages/TopicList.vue');
const TopicDetail = () => import('@/pages/TopicDetail.vue');
const Campaign = () => import('@/pages/Campaign.vue');
const CouponAttachment = () => import('@/pages/CouponAttachment.vue');
const HomePage = () => import('@/pages/Home.vue');
const HutPage = () => import('@/pages/Hut.vue');
const CategoryPage = () => import('@/pages/Category.vue');
const ContactPage = () => import('@/pages/static/Contact.vue');
const ContactUsPage = () => import('@/pages/static/Contactus.vue');
const AboutUsPage = () => import('@/pages/static/About.vue');
const PrivacyPolicyPage = () => import('@/pages/static/PrivacyPolicy.vue');
const Feedback = () => import('@/pages/static/Feedback.vue');
const TermsPage = () => import('@/pages/static/Terms.vue');
const LoginPage = () => import('@/pages/Login.vue');
const CheckoutPage = () => import('@/pages/CheckOut.vue');
const TrackerOrder = () => import('@/pages/TrackerOrder.vue');
const Tracking = () => import('@/pages/Tracking.vue');
const MyRewards = () => import('@/pages/MyRewards.vue');
const CreditCardPayment = () => import('@/pages/CreditCardPayment.vue');
const CybersourcePayment = () => import('@/pages/CybersourcePayment.vue');
const GameSlot = () => import('@/pages/GameSlot.vue');
const GameReward = () => import('@/pages/GameReward.vue');
const GameSuccess = () => import('@/pages/GameSuccess.vue');
const Rakuten = () => import('@/components/Rakuten.vue');

Vue.use(Router)

let router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.name == 'home') {
      return { x: 0, y: 0 }
    }
  },
  hashbang: false,
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/huts/:outlet',
      name: 'huts',
      meta: {layout: 'home-landing'},//home-landing
      component: HutPage
    },
    {
      path: '/order/:slug?/:sub?/:nameseo?',
      name: 'category',
      meta: {layout: 'main'},
      component: CategoryPage
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {layout: 'simple', 'key_title': 'header.contact'},
      component: ContactPage
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      meta: {
        layout: 'simple',
        'key_title': 'header.contact_us',
        meta_title: 'Contact Us : Pizza Hut Kuwait',
        h1_tag: 'Contact Us '
      },
      component: ContactUsPage
    },
    {
      path: '/about-us',
      name: 'about-us',
      meta: {
        layout: 'simple',
        'key_title': 'header.about_us',
        meta_title: 'About : Pizza Hut Kuwait ',
        h1_tag: 'About Pizza Hut '
      },
      component: AboutUsPage
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      meta: {
        layout: 'simple',
        'key_title': 'header.privacy_policy',
        meta_title: 'Privacy Policy : Pizza Hut Kuwait',
        h1_tag: 'Privacy Policy '
      },
      component: PrivacyPolicyPage
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: {
        layout: 'simple',
        'key_title': 'header.feedback',
        meta_title: 'Feedback : Pizza Hut Kuwait',
        h1_tag: 'Feedback'
      },
      component: Feedback
    },
    {
      path: '/login/:method?',
      props: true,
      name: 'login',
      component: LoginPage,
      meta: {
        layout: 'simple',
        'key_title': 'header.login',
        meta_title: 'Login to Your Account : Pizza Hut Kuwait',
        h1_tag: 'Pizza Hut Kuwait Login '
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'simple',
        'key_title': 'header.register',
        auth: false,
        meta_title: 'Register Your Account : Pizza Hut Kuwait ',
        h1_tag: 'Register an Account in Pizza Hut Kuwait '
      }
    },
    {
      path: '/getmypassword',
      component: ForgotPassword,
      meta: {
        layout: 'simple',
        'key_title': 'header.reset_password',
        meta_title: 'Reset Password : Pizza Hut Kuwait',
        h1_tag: 'Reset Password '
      }
    },
    {
      path: '/setnewpassword/:token',
      component: SetNewPassWord,
      meta: {layout: 'simple', 'key_title': 'header.create_new_password'}
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {layout: 'simple', 'key_title': 'header.my_account_information', auth: true}
    },
    {
      path: '/edit-profile',
      component: EditProfile,
      meta: {layout: 'simple', 'key_title': 'header.update_information', auth: true}
    },
    {
      path: '/ponta-attach',
      name: 'ponta-attach',
      component: Ponta,
      meta: {layout: 'simple', 'key_title': 'header.ponta', auth: true}
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: CheckoutPage,
      meta: {layout: 'simple', 'key_title': 'header.secure_checkout'}
    },
    {
      path: '/credit-payment/:transaction?/:payment_url?',
      name: 'credit-payment',
      component: CreditCardPayment,
      meta: {layout: 'simple', 'key_title': 'header.credit_card'}
    },
    {
      path: '/cybersource-payment/:uuid?',
      name: 'cybersource-payment',
      component: CybersourcePayment,
      meta: {layout: 'simple', 'key_title': 'header.credit_card'}
    },
    {
      path: '/tracker-order/:uuid?',
      name: 'tracker-order',
      component: TrackerOrder,
      meta: {layout: 'simple', 'key_title': 'header.thanks_for_your_order'}
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: Tracking,
      meta: {layout: 'simple', 'key_title': 'header.track_your_order'}
    },
    {
      path: '/my-rewards',
      name: 'my-rewards',
      component: MyRewards,
      meta: {
        layout: 'simple',
        'key_title': 'imgs',
        meta_title: 'Rewards : Pizza Hut Kuwait',
        h1_tag: 'Pizza Hut Kuwait Rewards Program '
      }
    },
    {
      path: '/add-location/:id?',
      name: 'add-location',
      component: AddLocation,
      meta: {layout: 'simple', 'key_title': 'header.location'}
    },
    {
      path: '/payment-status/:transaction?',
      name: 'payment-status',
      component: PaymentStatus,
      meta: {layout: 'simple', 'key_title': 'header.thanks_for_your_payment'}
    },
    {
      path: '/aboutus/:id?',
      name: 'aboutus',
      component: Aboutus,
      meta: {layout: 'simple', 'key_title': 'header.aboutus'}
    },
    {
      path: '/careers/:id?',
      name: 'careers',
      component: Careers,
      meta: {layout: 'simple', 'key_title': 'header.careers'}
    },
    {
      path: '/news/:year?/:month?/:url?',
      name: 'news',
      component: News,
      meta: {layout: 'simple', 'key_title': 'header.news'}
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.policy'},
      props: {type: 'privacy_policy', name: 'policy'}
    },
    {
      path: '/terms',
      name: 'terms',
      component: TermsPage,
      meta: {
        layout: 'simple',
        'key_title': 't_and_c',
        meta_title: 'Terms & Conditions : Pizza Hut Kuwait',
        h1_tag: 'Pizza Hut Terms & Conditions '
      }
    },
    {
      path: '/membership',
      name: 'membership',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.membership'},
      props: {type: 'membership_information', name: 'membership'}
    },
    {
      path: '/indication-based',
      name: 'indication',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.indication'},
      props: {type: 'cmn_commercial_transactions', name: 'commercial-transactions'}
    },
    {
      path: '/nutritional-content',
      name: 'nutritional',
      component: Post,
      meta: {
        layout: 'simple',
        'key_title': 'header.nutritional',
        meta_title: 'Nutrition Facts & Calories Information : Pizza Hut Kuwait ',
        h1_tag: 'Nutritional Information '
      },
      props: {type: 'prd_allergen', name: 'nutritional'}
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        layout: 'simple',
        'key_title': 'header.faq_full',
        meta_title: 'Frequently Asked Questions (FAQs): Pizza Hut Kuwait',
        h1_tag: 'Frequently Asked Questions '
      }
    },
    {
      path: '/crm/coupon/:code?',
      name: 'coupon-attach',
      component: CouponAttachment,
      meta: {layout: 'simple', 'key_title': 'header.coupon_attachment'},
      props: true
    },
    /*{
				path: '/term',
				name: 'term',
				component: Term,
				meta: {layout: 'simple', 'key_title': 'header.terms'}
		},*/
    {
      path: '/crs/:mode?/:sub?',
      name: 'crs',
      component: Crs,
      meta: {layout: 'simple', 'key_title': 'header.crs'}
    },
    {
      path: '/history',
      component: History,
      meta: {layout: 'simple', 'key_title': 'header.history', auth: true}
    },
    {
      path: '/combo-detail/:nameseo/:ssid?/:coupon?',
      name: 'combo-detail',
      component: ComboDetail,
      meta: {layout: 'combo', 'key_title': 'header.combo_detail'}
    },
    {
      path: '/localization/:zip/:opt?',
      name: 'test-localization',
      component: TestLocalization,
      meta: {
        layout: 'simple',
        'key_title': 'postal_code',
        'sub_title': 'localization.sub_title_result_search',
        key_params: 'zip'
      }
    },
    {
      path: '/result-localization/:zip/:opt?',
      name: 'result-localization',
      component: ResultLocalization,
      meta: {layout: 'simple', 'key_title': 'localization.title_result_search', key_params: 'zip'}
    },
    {
      path: '/confirmation/:regis',
      name: 'confirmation',
      component: Confirmation,
      meta: {layout: 'simple', 'key_title': 'registration.thankyou', key_params: 'regis'}
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        layout: 'home',
        meta_title: 'Pizza Hut Kuwait : Order Pizza Online - Delivery & Takeaway',
        h1_tag: 'Welcome to Pizza Hut Kuwait '
      },
      component: HomePage
    },
    {
      path: '/topic',
      name: 'topic',
      component: TopicList,
      meta: {layout: 'main', 'key_title': 'header.topic'},
    },
    {
      path: '/topic/:name/:code?',
      name: 'topic-detail',
      component: TopicDetail,
      meta: {layout: 'main', 'key_title': 'header.topic'}
    },
    {
      path: '/campaign/:campaignName',
      name: 'campaign',
      component: Campaign,
      meta: {layout: 'Simple', 'key_title': 'header.campaign'}
    },
    {
      path: '/slot',
      name: 'game_slot',
      component: GameSlot,
      meta: {layout: 'null'},
    },
    {
      path: '/slot_reward',
      name: 'game_slot_reward',
      component: GameReward,
      meta: {layout: 'null'},
    },
    {
      path: '/slot_success',
      name: 'game_slot_success',
      component: GameSuccess,
      meta: {layout: 'null'},
    },
    {
      path: '*',
      // redirect: {name: 'home'},
      beforeEnter: (to, from, next) => {
        const login = [
          '/pc/cpn_search',
          '/pc/user_password_reset',
          '/pc/user_detail.2',
          '/pc/user_base_modify.3',
          '/pc/user_password_modify.5',
          '/pc/user_mail_modify.7',
          '/user_mail_modify_confirm.8',
          '/user_mail_modify_mail_sent.9',
          '/pc/user_family_modify.13',
          '/pc/user_pontacard_modify.15'
        ]
        const topics = [
          '/pc/topics'
        ]
        const faq = [
          '/pc/general/include/cmn_inquiry.html'
        ]
        const member = [
          '/pc/general/include/usr_member_rules.html'
        ]

        const nutrition = [
          '/pc/general/include/prd_allergen.html?link_id=cft_par'
        ]
        const actTrade = [
          '/pc/general/include/cmn_commercial_transactions.html?link_id=cft_cct'
        ]

        const stores = [
          '/ip/shop_detail',
          '/pc/shop_detail'
        ]

        for (let i in stores) {
          if (lodash.startsWith(to.fullPath, stores[i])) {
            let path = to.fullPath.split('/')
            if (path.length >= 4) {
              return next('/huts/' + path[3])
            }
          }
        }

        for (let i in topics) {
          if (lodash.startsWith(to.fullPath, topics[i])) {
            return next('/topic')
          }
        }

        for (let i in login) {
          if (lodash.startsWith(to.fullPath, login[i])) {
            return next('/login')
          }
        }

        for (let i in faq) {
          if (lodash.startsWith(to.fullPath, faq[i])) {
            return next('/faq')
          }
        }

        for (let i in member) {
          if (lodash.startsWith(to.fullPath, member[i])) {
            return next('/membership')
          }
        }

        for (let i in nutrition) {
          if (lodash.startsWith(to.fullPath, nutrition[i])) {
            return next('/nutritional-content')
          }
        }

        for (let i in actTrade) {
          if (lodash.startsWith(to.fullPath, actTrade[i])) {
            return next('/indication-based')
          }
        }
        next('/home')
      }
    },
    {
      path: '/cgi-bin/linkshare',
      component: Rakuten
    }
  ]
});

router.beforeResolve((to, from, next) => {
  //vm.$bus.$emit(constants.EVENT_BUS.LOADING, true)
  next()
})

router.afterEach((to, from) => {
  let title = main.$t(to.meta.meta_title)
  let description = main.$t(to.meta.meta_description)
  let keywordsEl = document.getElementsByTagName('meta')['keywords']
  if (keywordsEl) {
    keywordsEl.content = main.$t('meta.meta_keywords')
  } else {
    main.generateMetaKeywordsTag(main.$t('meta.meta_keywords'))
  }

  if (!title) {
    title = main.$t('meta.meta_title')
  }
  if (!description) {
    description = main.$t('meta.meta_description')
  }
  if (to.meta.h1_tag) {
    if (document.getElementsByTagName('h1') && document.getElementsByTagName('h1').length > 0) {
      document.getElementsByTagName('h1')[0].innerHTML = to.meta.h1_tag
    } else {
      const newDiv = document.createElement('h1')
      newDiv.classList.add('invisible', 'p-absolute')
      const newContent = document.createTextNode(to.meta.h1_tag)
      newDiv.appendChild(newContent)
      const currentDiv = document.getElementById('app')
      document.body.insertBefore(newDiv, currentDiv)
    }
  }
  document.title = main.$t(title)

  const curFullURL = `https://${window.location.hostname}${to.fullPath}`
  /**
   * Canonical
   *    example: <link rel="canonical" href="https://www.pizzahut.com.my" />
   */
  const existedCanonical = document.querySelector('[rel="canonical"]')
  if (existedCanonical) {
    existedCanonical.remove()
  }
  let canonicalEl = document.createElement('link')
  canonicalEl.setAttribute('rel', 'canonical')
  canonicalEl.setAttribute('href', curFullURL)
  document.head.appendChild(canonicalEl)

  if (document.getElementsByTagName('meta')["description"] === undefined) {
    main.generateMetaDescriptionTag(main.$t(description))
  } else { // existed
    let descriptionEl = document.getElementsByTagName('meta')["description"]
    descriptionEl.content = description
  }

  if( ['profile','checkout','tracker-order'].indexOf(to.name) > -1 ) {
    if(document.getElementsByTagName('meta')["robots"] === undefined) {
      let meta = document.createElement('meta')
      meta.setAttribute('name', "robots")
      meta.setAttribute('content', 'noindex')
      document.head.appendChild(meta);
    } else { // existed
      let robots_meta_el = document.getElementsByTagName('meta')["robots"]
      robots_meta_el.content = 'noindex'
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js